import * as React from "react";

import { convertDateStructToDate, convertDateToDateStruct, IDateStruct } from "../../../classes/data";
import { EndsOnType, IEndsOn } from "../../../classes/recurrencePattern";
import { IText } from "../../../classes/text";
import { IText_AddEditEvent } from "../../../classes/text_AddEditEvent";

import { JQDateAndTimePicker } from "../../../../common/JQDateAndTimePicker/JQDateAndTimePicker";

import { DataService } from "../../../data/DataService";

import * as dates from "../../../reducers/changeTimePeriod";

export interface IRecurrencePatternEnd {
	addEditText: IText_AddEditEvent;
	endsOn: IEndsOn;
	firstDayOfWeek: string;
	onChangeEndsOn: (endsOn: IEndsOn) => void;
	saveHasBeenClicked: boolean;
	startDate: Date;
	text: IText;
	userDateFormat: string;
	validationEndDateIsSet: boolean;
	validationEndDateIsEqualToOrAfterStartDate: boolean;
}

export const RecurrencePatternEnd: React.SFC<IRecurrencePatternEnd> = (props) => {

	const [selectedEndsAfterXRecurrences, setSelectedEndsAfterXRecurrencesInState] = React.useState(getInitialEndsAfterXRecurrences(props));
	const [selectedEndsOnDate, setSelectedEndsOnDateInState] = React.useState(getInitialEndsOnDate(props));

	const endsOnType = props.endsOn && props.endsOn.endsOnType ? props.endsOn.endsOnType : "neverEnds";

	const getEndsAfterXRecurrencesDropdownOptions = (minOptionVal: number, maxOptionVal: number) => {
		const dropdownOptions = [];
		for (let i = minOptionVal; i <= maxOptionVal; i++) {
			dropdownOptions.push(<option value={i} key={"repEndsAfterX" + i.toString()}>{i}</option>);
		}
		return dropdownOptions;
	};
	const endsAfterXRecurrencesDropdownOptions = getEndsAfterXRecurrencesDropdownOptions(1, 99);

	const onChangeEndsOnType = (newEndsOnType: EndsOnType): void => {
		const newEndsOn: IEndsOn = { endsOnType: newEndsOnType };

		if (newEndsOnType === "neverEnds") {
			setSelectedEndsOnDateInState(null);
			setSelectedEndsAfterXRecurrencesInState(1);
		}

		if (newEndsOnType === "endsAfterXRecurrences") {
			newEndsOn.numberOfRecurrences = selectedEndsAfterXRecurrences;
			setSelectedEndsOnDateInState(null);
		}

		if (newEndsOnType === "endsOnDate") {
			if (selectedEndsOnDate) {
				newEndsOn.endsOnDate = convertDateToDateStruct(selectedEndsOnDate);
			}
			setSelectedEndsAfterXRecurrencesInState(1);
		}

		props.onChangeEndsOn(newEndsOn);
	};

	const onChangeEndsAfterXRecurrencesDropdown = (event: any): void => {
		event.preventDefault();
		const value = event.target.value;
		const intValue = parseInt(value, 10);
		if (Number.isInteger(intValue) && intValue >= 1 && intValue <= 99) {
			// Update in local state.
			setSelectedEndsAfterXRecurrencesInState(Number(value));
			// Update via callback.
			if (props.endsOn.endsOnType === "endsAfterXRecurrences") {
				const newEndsOn: IEndsOn = { ...props.endsOn };
				newEndsOn.numberOfRecurrences = Number(intValue);
				props.onChangeEndsOn(newEndsOn);
			}
		}
	};

	const onChangeEndsOnDateFieldValue = (newValue: Date): void => {
		newValue = dates.setHourAndMinute(newValue, 0, 0);
		// Update in local state.
		setSelectedEndsOnDateInState(newValue);
		// Update via callback.
		if (props.endsOn.endsOnType === "endsOnDate") {
			const newEndsOn: IEndsOn = { ...props.endsOn };
			newEndsOn.endsOnDate = convertDateToDateStruct(newValue);
			props.onChangeEndsOn(newEndsOn);
		};
	};

	const text = props.addEditText.general;
	const valText = props.addEditText.validation;

	return (
		<form data-testid="form_rbEndsOn">
			<div className="CMS_e_row">
				<div className="CMS_iInline">
					<div className="CMS_title CMS_T6"><label htmlFor="end-ui">{text.endRecurrence}:</label></div>
					<div className="CMS_iiFields" id="end-ui">
						<div className="CMS_e_row">
							<div className="CMS_iInlineText">
								<label className="CMS_radio CMS_radio_noText" htmlFor="rbNeverEnds"><input type="radio" id="rbNeverEnds" data-testid="rb-neverEnds" className="CMS_input" checked={endsOnType === "neverEnds"} onChange={(event) => onChangeEndsOnType("neverEnds")} name="rbEndsOn" value="neverEnds"/><span><em className="fa" aria-hidden="true"></em></span></label>
								<span>{text.never}</span>
							</div>
						</div>
						<div className="CMS_e_row">
							<div className="CMS_iInlineText">
								<label className="CMS_radio CMS_radio_noText" htmlFor="rbEndsAfterXRecurrences"><input type="radio" id="rbEndsAfterXRecurrences" data-testid="rb-endsAfterXRecurrences" className="CMS_input" checked={endsOnType === "endsAfterXRecurrences"} onChange={(event) => onChangeEndsOnType("endsAfterXRecurrences")} name="rbEndsOn" value="endsAfterXRecurrences" /><span><em className="fa" aria-hidden="true"></em></span></label>
								<span>{text.after}</span>
								<select data-testid="input-endsAfterXRecurrences" className="CMS_input CMS_noWidth" onChange={(event) => onChangeEndsAfterXRecurrencesDropdown(event)} value={selectedEndsAfterXRecurrences}>
									{endsAfterXRecurrencesDropdownOptions}
								</select>
								<span>{text.occurences}</span>
							</div>
						</div>
						<div className="CMS_e_row">
							<div className="CMS_iInlineText">
								<label className="CMS_radio CMS_radio_noText" htmlFor="rbEndsOnDate"><input type="radio" id="rbEndsOnDate" data-testid="rb-endsOnDate" className="CMS_input" checked={endsOnType === "endsOnDate"} onChange={(event) => onChangeEndsOnType("endsOnDate")} name="rbEndsOn" value="endsOnDate" /><span><em className="fa" aria-hidden="true"></em></span></label>
								<span>{text.on}</span>
								<JQDateAndTimePicker
									currentDate={selectedEndsOnDate}
									displayTimePickerUI={false}
									firstDayOfWeek={props.firstDayOfWeek}
									getLatestDateNowForUser={getLatestDateNowForUser}
									id={"endsOnDatePicker"}
									inputElementAdditionalCSS={"CMS_noWidth"}
									inputElementHardCodedStyle={{ minWidth: "230px" }}
									onBlurSelectedDate={() => null}
									onChangeSelectedDate={onChangeEndsOnDateFieldValue}
									text={props.addEditText.dateAndTimePicker}
									userDateFormat={props.userDateFormat}
								/>
								{!props.validationEndDateIsSet && props.saveHasBeenClicked &&
									<div className="CMS_inlineAlerts CMS_error">{valText.dateThatRecurrenceEndsOnIsRequired}</div>
								}
								{!props.validationEndDateIsEqualToOrAfterStartDate && props.saveHasBeenClicked &&
									<div className="CMS_inlineAlerts CMS_error">{valText.dateThatRecurrenceEndsOnMustBeEqualToOrAfterStartDate} ({dates.format(props.startDate, props.userDateFormat)})</div>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		</form>
	);
};

const getInitialEndsAfterXRecurrences = (props: IRecurrencePatternEnd): number => {
	if (props.endsOn && props.endsOn.numberOfRecurrences) {
		return props.endsOn.numberOfRecurrences;
	} else {
		return 1;
	};
};

const getInitialEndsOnDate = (props: IRecurrencePatternEnd): Date => {
	if (props.endsOn && props.endsOn.endsOnDate) {
		return convertDateStructToDate(props.endsOn.endsOnDate);
	} else {
		return null;
	};
};

const getLatestDateNowForUser = (): IDateStruct => {
	// A little unorthodox... making a direct call to get the user's current time on server, not going through Redux flow.
	const dataService = new DataService();
	return dataService.latestDateNowForUser().then((response: any) => {
		if (response.d !== undefined) { response = response.d; } // .NET service wraps response in a 'd' property.
		const dateNowForUser: IDateStruct = response;
		return dateNowForUser;
	});
};
